import { createSelector } from '@reduxjs/toolkit';
import { driveSlice } from './slice';
export const selectDrive = createSelector((state) => state, (state) => state[driveSlice.name]);
export const selectDriveDetails = createSelector(selectDrive, (state) => state?.driveData ?? null);
export const selectIsSlotDetailsLoading = createSelector(selectDrive, (state) => state?.loading ?? false);
